import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VitaDiagnostics } from '../../../services/vita-wallet.service';

/**
 * Diálogo de diagnóstico de conexión con Vita.
 * Muestra: ambiente, baseUrl, xLogin fingerprint, variantes publicadas por
 * Vita en vivo, y un check rápido de presencia de CO/COCOP/COBREB (útil para
 * verificar alineación con lo que Vita dice que está publicando).
 */
@Component({
  selector: 'app-diagnostics-dialog',
  templateUrl: './diagnostics-dialog.component.html',
  styleUrls: ['./diagnostics-dialog.component.sass'],
})
export class DiagnosticsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DiagnosticsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VitaDiagnostics,
  ) {}

  get isProd(): boolean {
    return (this.data.environment || '').toLowerCase() === 'prod';
  }

  get hasErrors(): boolean {
    return (this.data.errors?.length ?? 0) > 0;
  }

  get priceVariantsSorted(): string[] {
    return [...(this.data.prices?.variants ?? [])].sort();
  }

  get ruleVariantsSorted(): string[] {
    return [...(this.data.rules?.variants ?? [])].sort();
  }

  close(): void {
    this.dialogRef.close();
  }
}
